import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { NavPerformance } from './nav-performance.preset';
import { nonResizableDialogPassThrough } from './non-resizable-dialog.pass-through';

export const provideNavPerformanceUi = () => [
  provideAnimationsAsync(),
  providePrimeNG({
    theme: {
      preset: NavPerformance,
      options: {
        prefix: 'p',
        darkModeSelector: '.app-dark',
        cssLayer: {
          name: 'primeng',
          order: 'theme, base, primeng',
        },
      },
    },
    // PrimeNG's own defaults are overlay/menu: 1000, modal/tooltip: 1100 — the app-bar's
    // fixed header sits at z-index 1030, right in between, so any overlay-type component
    // (calendar/date picker, select dropdowns, menus) renders underneath it. Raising
    // overlay/menu to match modal/tooltip keeps every PrimeNG popup above the header.
    zIndex: {
      modal: 1100,
      overlay: 1100,
      menu: 1100,
      tooltip: 1100,
    },
    pt: nonResizableDialogPassThrough,
  }),
];
